import axios from 'axios'
import { message } from 'ant-design-vue'
import i18n from '../lang'

const websocketUrl = 'ws://10.55.50.82:10000/ws/device'

const request = axios.create({
  // baseURL: 'https://ygk.deman.cn/api',
  // baseURL: 'http://10.55.50.82',
  // baseURL: 'http://10.55.50.85:10000/api/',
  // baseURL: 'http://10.55.50.87:10000/api/',
  baseURL: 'https://ygk.deman.cn/api/v2',
  timeout: 180000,
  withCredentials: false
})

function setTokenToHeader (requestConfig) {
  if (localStorage.getItem('token')) {
    const token = JSON.parse(localStorage.getItem('token'))
    if (token) {
      requestConfig.headers.Authorization = `Bearer ${token}`
    }
  }
}

request.interceptors.request.use(requestConfig => {
  setTokenToHeader(requestConfig)
  return requestConfig
},
error => {
  return Promise.reject(error)
})

request.interceptors.response.use(response => {
  const { data, config } = response
  const { code } = data
  if (response.data.type === 'application/vnd.ms-excel' || response.data.type === 'text/xml' || response.data.type === 'application/vnd.ms-excel;charset=utf-8' || response.data.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    return Promise.resolve(response)
  }
  if (code === 0 || config.url === '/screen') {
    if (config.url.startsWith('/customer_profile')) {
      const { data: customerData } = data
      return Promise.resolve(customerData)
    } else {
      return Promise.resolve(data)
    }
  } else if (code === 4002 || code === 4003 ||code === 1102) {
    message.warn(i18n.t('logFail'))
    localStorage.removeItem('token')
    localStorage.removeItem('rToken')
  } else if (code === 300000 && config.url.startsWith('/crm/getCorporateInformation')) {
    message.warn(data.message || i18n.t('messages.placeSearchFail'))
  }else {
    message.warn(i18n.t('messages.fetchFail'))
    return Promise.reject(data)
  }
}, error => {
  message.warn(error?.message || i18n.t('messages.fetchFail'))
  return Promise.reject(error)
})

export default request

export {
  websocketUrl
}
